export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10601.a5b04b19.jpg";